(function ($, window) {
	'use strict';

	$(function () {
		// Initialize headroom
		(new Headroom(document.querySelector('.jsStickyHeader'))).init();
	});
})(jQuery, window);
